// styles.js
import styled from "styled-components";

export const AddressForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  padding: 1rem;
  background-color: ${props => props.theme.colors.fourth};
  border-radius: 4px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid ${props => props.theme.colors.secondary};
  border-radius: 4px;
`;

export const Button = styled.button`
  width: 100%;
  padding: 1rem;
  margin-top: 1rem;
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.labelButton};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${props => props.theme.colors.primary};
  }
`;
